/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsCanvasPreview
 */
export interface SharedserviceMelcoModelsCanvasPreview {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsCanvasPreview
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsCanvasPreview
     */
    url?: string | null;
}

export function SharedserviceMelcoModelsCanvasPreviewFromJSON(json: any): SharedserviceMelcoModelsCanvasPreview {
    return SharedserviceMelcoModelsCanvasPreviewFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsCanvasPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsCanvasPreview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function SharedserviceMelcoModelsCanvasPreviewToJSON(value?: SharedserviceMelcoModelsCanvasPreview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'url': value.url,
    };
}


